import { Popover } from '@radix-ui/themes';
import { AxiosResponse } from 'axios';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import notificationImage from '../../../../../assets/images/notification-image.png';
import arrowRightIcon from '../../../../../assets/svgs/arrow_right-icon.svg';
import chevronLeftCircleIcon from '../../../../../assets/svgs/chevron_left_circle-icon.svg';
import closeIcon from '../../../../../assets/svgs/close-icon.svg';
import deleteIcon from '../../../../../assets/svgs/delete-icon.svg';
import notificationIcon from '../../../../../assets/svgs/notification-icon.svg';
import settingsIcon from '../../../../../assets/svgs/settings-icon.svg';
import { CustomIcon } from '../../../../../components/widgets/CustomIcon';
import { TooltipComponent } from '../../../../../components/widgets/Tooltip';
import { useMediaQuery } from '../../../../../hooks/useMediaQuery';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { isDadosLoginTokenValid } from '../../../../../utils/dados-login.util';
import { useNotificationContext } from '../context/NotificationContext';
import {
  NotificationPopoverProps,
  NotificationType_
} from '../types/notificationTypes';
import { getDateFormatted } from '../utils/getDateFormatted';

const apiNotificacoes = apiSensedia;

export const NotificationPopover = ({
  buttonsMobile,
  rightSpace,
  topSpace,
  children
}: NotificationPopoverProps) => {
  const navigate = useNavigate();
  const {
    toggleNotifications,
    openNotifications,
    unreadNotificationsTotal,
    setUnreadNotificationsTotal
  } = useNotificationContext();
  const location = useLocation();

  const isMobile = useMediaQuery('(max-width: 700px)');

  const [notifications, setNotifications] = useState<NotificationType_[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [notShowNotificationToast, setNotShowNotificationToast] =
    useState(false);

  const notificationObj = {
    'novo lead': 'Você recebeu um novo lead.',
    'novos leads': 'Você recebeu novos leads.',
    'nova venda': 'Uma venda acaba de ser concluída.',
    'novo agendamento': 'Você tem um agendamento',
    'novos agendamentos': 'Você tem novos agendamentos'
  };

  const buttonsMobileDefault = buttonsMobile
    ? buttonsMobile
    : [
        {
          icon: <CustomIcon src="" />,
          label: 'Ver todas as notificações',
          border: 'transparent',
          color: '#FFFFFF',
          background: '#001E64',
          action: () => {
            navigate('/corretor/notificacoes');
            enableScroll();
          },
          disable: false
        },
        {
          icon: (
            <CustomIcon
              src={settingsIcon}
              width={21}
              height={19}
              color="#2A4E9A"
            />
          ),
          label: 'Configurar notificação',
          border: '#2A4E9A',
          color: '#2A4E9A',
          background: '#FFFFFF',
          action: () => {
            navigate('/corretor/notificacoes/configuracoes');
            enableScroll();
          },
          disable: false
        }
      ];

  const getTotalNotifications = async () => {
    const userDataToken = localStorage.getItem('user-data-token');
    try {
      const response = await apiNotificacoes.get(
        `/notificacoes/notificacoes-tela?lida=false&_limit=1&_offset=0`,
        {
          headers: {
            'user-data-info': userDataToken
          }
        }
      );

      setUnreadNotificationsTotal(response.data._embedded._total);
    } catch (error) {
      console.log(error);
    }
  };

  const getNotifications = async () => {
    const parsedUser = JSON.parse(user);
    const isUserDataTokenValid = isDadosLoginTokenValid();
    const userDataToken = localStorage.getItem('user-data-token');

    const isUserLoggedIn = parsedUser?.user;

    const pathname = location.pathname;

    if (
      pathname.includes('/corretor') &&
      isUserLoggedIn &&
      tokenPortal &&
      isUserDataTokenValid
    ) {
      setIsLoading(true);

      let responseLida = {} as AxiosResponse;
      let responseNoLida = {} as AxiosResponse;

      let isLoading = true;
      let attempts = 0;
      const maxAttempts = 3;

      while (attempts < maxAttempts) {
        try {
          responseLida = await apiNotificacoes.get(
            `/notificacoes/notificacoes-tela?lida=false&_limit=3&_offset=0`,
            {
              headers: {
                'user-data-info': userDataToken
              }
            }
          );

          responseNoLida = await apiNotificacoes.get(
            `/notificacoes/notificacoes-tela?lida=true&_limit=3&_offset=0`,
            {
              headers: {
                'user-data-info': userDataToken
              }
            }
          );

          const items = [
            ...responseLida.data._embedded._result,
            ...responseNoLida.data._embedded._result
          ];

          setNotifications(items.slice(0, 3));
          isLoading = false;

          break;
        } catch (e: any) {
          attempts++;

          if (e.response.status === 401) {
            console.log('Ocorreu erro interno', e.response.statusText);
            console.log('Detalhes do erro', e.response.data);
            isLoading = false;
          }

          if (attempts === maxAttempts) {
            console.log('Número máximo de tentativas atingido.');
            isLoading = false;
          }
        }
      }
      setIsLoading(isLoading);
    }
  };

  const deleteNotifications = async (id: string) => {
    try {
      await apiNotificacoes.delete(`notificacoes/notificacoes-tela?ids=${id}`);
      const newNotifications = notifications.filter((item) => item.id !== id);

      setNotifications(newNotifications);
      getTotalNotifications();
    } catch (error) {
      console.log(error);
    }
  };

  const handlePageRedirection = (path?: string) => {
    window.location.pathname = `/${path ? path : ''}`;
  };

  const headersIcons = [
    {
      icon: settingsIcon,
      tolltip: 'Configurar notificação',
      action: handlePageRedirection
    }
  ];

  const pathName = window.location.pathname;

  const disableScroll = () => {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  };

  const enableScroll = () => {
    document.documentElement.style.overflow = 'auto';
    document.body.style.overflow = 'auto';
  };

  const user = localStorage.getItem('pdn:user');
  const tokenPortal = localStorage.getItem('tokenPortal');

  useEffect(() => {
    getNotifications();
  }, [location.pathname, tokenPortal]);

  useEffect(() => {
    setNotShowNotificationToast(
      pathName.length <= 1 ||
        pathName.startsWith('/login') ||
        pathName.startsWith('/confirmacao-email')
    );
  }, [location]);

  return (
    <Popover.Root open={openNotifications} onOpenChange={toggleNotifications}>
      <Popover.Trigger
        style={{
          display: notShowNotificationToast ? 'none' : 'block'
        }}
      >
        <button
          style={{
            right: rightSpace ? rightSpace : isMobile ? '7rem' : '13rem',
            top: topSpace ? topSpace : '2rem'
          }}
          className="tw-absolute tw-top-8 tw-text-[#001E64] tw-flex"
          onClick={() => {
            toggleNotifications();
            if (isMobile) {
              disableScroll();
            }
          }}
        >
          <CustomIcon
            src={notificationIcon}
            width={isMobile ? 24 : 28}
            height={28}
          />
          {unreadNotificationsTotal > 0 && (
            <div className="tw-bg-[#AA2C23] tw-text-white tw-rounded-full tw-w-[0.9rem] tw-p-2 tw-h-[0.9rem] tw-text-[0.575rem] tw-font-bold tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-4">
              {unreadNotificationsTotal}
            </div>
          )}
        </button>
      </Popover.Trigger>
      {isMobile && openNotifications ? (
        <div className="tw-fixed tw-top-0 tw-left-0 tw-h-[100vh] tw-w-full tw-bg-white tw-text-base tw-flex tw-flex-col tw-justify-between tw-z-10">
          <div className="tw-flex tw-justify-between tw-items-center tw-bg-[#F4F4F4] tw-py-5 tw-px-4">
            <button
              className="tw-focus:outline-none tw-text-[#001E64]"
              onClick={() => {
                toggleNotifications();
                if (isMobile) {
                  enableScroll();
                }
              }}
            >
              <CustomIcon src={chevronLeftCircleIcon} />
            </button>
            <p className="tw-text-[#323232] tw-text-xl tw-font-bold">
              Notificações
            </p>
            <button
              className="tw-focus:outline-none"
              onClick={() => {
                toggleNotifications();
                if (isMobile) {
                  enableScroll();
                }
              }}
            >
              <CustomIcon src={closeIcon} width={15} height={15} />
            </button>
          </div>
          <div className="tw-h-full tw-overflow-auto tw-bg-white">
            {notifications.length >= 1 ? (
              notifications?.map((item, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      borderBottom:
                        index + 1 !== notifications.length &&
                        '1px solid #F4F4F4'
                    }}
                    className="tw-flex tw-justify-between tw-pt-5 hover:tw-bg-[#E9EDF4] tw-transition-opacity"
                  >
                    <ul
                      style={{
                        color: item?.lida ? '#001E64' : '#FF5000'
                      }}
                      className="tw-list-disc"
                    >
                      <div className="tw-ml-6 tw-px-5 tw-pb-5">
                        <li className="tw-text-[1.5rem]">
                          <span className="tw-text-[1rem] tw-font-bold">
                            {item?.lida ? 'Lida' : 'Não Lida'}
                          </span>
                        </li>
                        <p className="tw-text-[#828282] tw-font-normal">
                          {getDateFormatted(item?.updated_at).date} &nbsp;
                          {getDateFormatted(item?.updated_at).time}
                        </p>
                        <strong className="tw-text-black">
                          {item?.assunto}
                        </strong>
                        <p className="tw-text-black tw-font-normal">
                          {notificationObj[String(item?.assunto).toLowerCase()]}
                        </p>
                        <button
                          style={{ color: item?.lida ? '#001E64' : '#FF5000' }}
                          className="tw-flex tw-gap-2 tw-underline tw-font-bold tw-mt-6"
                          onClick={() => {
                            toggleNotifications();
                            navigate('/corretor/notificacoes');
                          }}
                        >
                          Ver mais detalhes
                          <CustomIcon
                            src={arrowRightIcon}
                            width={20}
                            height={20}
                            color={item?.lida ? '#001E64' : '#FF5000'}
                          />
                        </button>
                      </div>
                    </ul>
                    <button
                      className="tw-flex tw-flex-col"
                      onClick={() => deleteNotifications(item?.id)}
                    >
                      <CustomIcon src={deleteIcon} />
                    </button>
                  </div>
                );
              })
            ) : (
              <p className="tw-text-[#828282] tw-text-5 tw-text-center tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-full">
                <img src={notificationImage} alt="notification-image" />
                Não há notificações!
              </p>
            )}
          </div>
          <hr />
          <div className="tw-py-5 tw-pt-7 tw-px-4">
            {buttonsMobileDefault
              .slice(
                notifications.length > 0 ? 0 : 1,
                notifications.length > 0 ? undefined : 2
              )
              .map((item, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      marginBottom:
                        index !== buttonsMobileDefault.length - 1 && '0.63rem'
                    }}
                  >
                    <button
                      disabled={item.disable}
                      // style={{
                      //   color: item.color,
                      //   background: item.background,
                      //   borderColor: item.border,
                      //   cursor: item.disable ? 'not-allowed' : 'pointer',
                      //   opacity: item.disable && '0.5'
                      // }}
                      className="md:tw-hidden tw-border tw-font-bold tw-px-11 tw-h-10 tw-rounded-full tw-w-full tw-flex tw-items-center tw-justify-center"
                      onClick={() => {
                        item.action();
                      }}
                    >
                      <div className="tw-flex tw-gap-2">
                        <span>{item.icon}</span>
                        <span>{item.label}</span>
                      </div>
                    </button>
                  </div>
                );
              })}
          </div>
        </div>
      ) : (
        <Popover.Content className="tw-overflow-auto tw-min-h-[16rem] tw-mt-5 tw-mr-8 tw-w-[27rem] tw-max-h-[37rem] tw-bg-white tw-flex-col tw-justify-between tw-shadow-[0px_0px_5px_rgba(50,50,50,0.25)] tw-rounded-xl tw-z-20">
          <div>
            <div className="tw-h-11 tw-flex tw-items-center tw-justify-between tw-px-5 tw-py-1.5 tw-bg-[#F4F4F4] tw-rounded-t-xl">
              <span>Notificações</span>
              <div className="tw-flex tw-gap-2">
                {headersIcons.map((icon, index) => {
                  return (
                    <TooltipComponent tooltip={icon.tolltip} key={index}>
                      <div
                        className="tw-rounded-full tw-bg-[#d2d2d2a3] hover:tw-bg-[#E9EDF4] tw-transition-opacity tw-flex tw-items-center tw-justify-center tw-p-2 tw-cursor-pointer"
                        onClick={() =>
                          icon.action('corretor/notificacoes/configuracoes')
                        }
                      >
                        <CustomIcon src={icon.icon} width={18} height={16} />
                      </div>
                    </TooltipComponent>
                  );
                })}
              </div>
            </div>
            {isLoading ? (
              <div className="tw-py-5 tw-flex tw-items-center tw-justify-center tw-h-64">
                <div
                  style={{ borderTopColor: 'transparent' }}
                  className="tw-w-12 tw-h-12 tw-border-4 tw-border-[#001E64] tw-border-solid tw-rounded-full tw-animate-spin"
                ></div>
              </div>
            ) : notifications.length >= 1 ? (
              notifications?.map((item, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      borderBottom:
                        index + 1 !== notifications.length &&
                        '1px solid #F4F4F4'
                    }}
                    className="tw-flex tw-justify-between tw-pt-5 tw-pr-6 hover:tw-bg-[#E9EDF4] tw-transition-opacity"
                  >
                    <ul
                      style={{
                        color: item?.lida ? '#001E64' : '#FF5000'
                      }}
                      className="tw-list-disc"
                    >
                      <div className="tw-ml-6 tw-px-5 tw-pb-5">
                        <li className="tw-text-[1.5rem]">
                          <span className="tw-text-[1rem] tw-font-bold">
                            {item?.lida ? 'Lida' : 'Não Lida'}
                          </span>
                        </li>
                        <p className="tw-text-[#828282] tw-font-normal">
                          {getDateFormatted(item?.updated_at).date} &nbsp;
                          {getDateFormatted(item?.updated_at).time}
                        </p>
                        <strong className="tw-text-black">
                          {item?.assunto}
                        </strong>
                        <p className="tw-text-black tw-font-normal">
                          {notificationObj[String(item?.assunto).toLowerCase()]}
                        </p>
                        <button
                          style={{ color: item?.lida ? '#001E64' : '#FF5000' }}
                          className="tw-flex tw-gap-2 tw-underline tw-font-bold tw-mt-6"
                          onClick={() => {
                            toggleNotifications();
                            navigate('/corretor/notificacoes');
                          }}
                        >
                          Ver mais detalhes
                          <CustomIcon
                            src={arrowRightIcon}
                            width={20}
                            height={20}
                            color={item?.lida ? '#001E64' : '#FF5000'}
                          />
                        </button>
                      </div>
                    </ul>
                    <button
                      className="tw-flex tw-flex-col"
                      onClick={() => deleteNotifications(item?.id)}
                    >
                      <CustomIcon src={deleteIcon} />
                    </button>
                  </div>
                );
              })
            ) : (
              <p className="tw-text-[#828282] tw-h-64 tw-text-5 tw-text-center tw-flex tw-flex-col tw-justify-center tw-items-center">
                <img src={notificationImage} alt="notification-image" />
                Não há notificações!
              </p>
            )}
          </div>
        </Popover.Content>
      )}
      {children}
    </Popover.Root>
  );
};
